<script>
    export let maps = [];
    import { createEventDispatcher } from 'svelte';
    import { texts, teamColours } from './texts.js';
    export let round;
    const dispatch = createEventDispatcher();
    export let mapChoice;
    // export let userName;
    export let teamName;
    export let isGameEnd = false;
    // export let isRoundOn = false;
    export let teamColour;
    export let lang;
    export let wantMap = false;
    export const mapTools = {
        cleanUpMap() {
            mapChoice = '';
            wantMap = false;
            for (let prop in mapLabels[lang]) {
                mapLabels[lang][prop].bought = false;
            }
        },
        weBoughtMap(colour) {
            mapLabels[lang][colour].bought = true;
            // console.log('weboughtmap', mapLabels[colour]);
        },
    };
    const colours = {
        Pomarańczowi: 'pomaranczowi',
        Zieloni: 'zieloni',
        Fioletowi: 'fioletowi',
        Niebiescy: 'niebiescy',
        trener: 'trener',
    };

    const teams = {
        teamA: 'pomaranczowi',
        teamB: 'zieloni',
        teamC: 'fioletowi',
        teamD: 'niebiescy',
        trener: 'trener',
    };
    const mapLabels = {
        pl: {
            pomaranczowi: { variant: 'pomarańczowych', bought: false },
            zieloni: { variant: 'zielonych', bought: false },
            fioletowi: { variant: 'fioletowych', bought: false },
            niebiescy: { variant: 'niebieskich', bought: false },
        },
        eng: {
            pomaranczowi: { variant: 'orange', bought: false },
            zieloni: { variant: 'green', bought: false },
            fioletowi: { variant: 'violet', bought: false },
            niebiescy: { variant: 'blue', bought: false },
        },
    };
    // let mapLabels = {
    //     pomaranczowi: { variant: 'pomarańczowych', bought: false },
    //     zieloni: { variant: 'zielonych', bought: false },
    //     fioletowi: { variant: 'fioletowych', bought: false },
    //     niebiescy: { variant: 'niebieskich', bought: false },
    // };
    const initialMapLabels = {
        pomaranczowi: { variant: 'pomarańczowych', bought: false },
        zieloni: { variant: 'zielonych', bought: false },
        fioletowi: { variant: 'fioletowych', bought: false },
        niebiescy: { variant: 'niebieskich', bought: false },
    };
    assignSelfLabel();

    function assignSelfLabel() {
        for (let prop in mapLabels[lang]) {
            console.log('ml', prop, teamColour);
            if (teamColour === prop) {
                console.log('changing!');
                mapLabels[lang][prop].variant = texts[lang].map_self;
                console.log('changed to', mapLabels[lang][prop].variant);
            }
        }
    }

    const findInObj = (val, obj) => {
        for (let prop in obj) {
            if (val === prop) return obj[prop];
        }
    };
    function mapBought() {
        if (!mapChoice) {
            Swal.fire({
                icon: 'warning',
                title: texts[lang].popup_choose_map_for,
            });
            return;
        }
        let colour = findInObj(mapChoice, teams);
        // console.log(colour);
        mapLabels[lang][colour].bought = true;
        let data = {
            nick: teamName,
            mapFor: mapChoice,
            mapForColour: colour,
        };
        dispatch('map-bought', data);
        mapChoice = '';
    }

    $: maps.forEach((transaction) => {
        //console.log(transaction);
        let colourFrom = findInObj(transaction[0], colours);
        let colourFor = findInObj(transaction[1], colours);
        //console.log(colour);
        if (colourFrom === teamColour) {
            mapLabels[lang][colourFor].bought = true;
        }
        //console.log(mapLabels);
    });
</script>

{#if round > 3 || isGameEnd}
    <div class="mapa">
        <h2>{texts[lang].map_header}<i class="fas fa-map" /></h2>
        <p>
            {texts[lang].map_explanation_part1}<i class="fas fa-coins" />
            {texts[lang].map_explanation_part2}<i class="fas fa-coins" />
            {texts[lang].map_explanation_part3}
        </p>

        {#if teamName !== 'trener' && !isGameEnd}
            <!-- <label>
                <input type="checkbox" bind:checked={wantMap} /> Chcemy mapę!
            </label> -->
            <div class="item1">
                <input
                    type="checkbox"
                    id="checkbox"
                    name="Checkbox"
                    class="visually-hidden"
                    bind:checked={wantMap}
                />
                <label for="checkbox"> {texts[lang].want_map}</label>
            </div>
        {/if}
        <div class="flex-container">
            {#if wantMap}
                <form>
                    <p>{texts[lang].map_for}</p>
                    <div class="item">
                        <input
                            class="radio visually-hidden"
                            type="radio"
                            id="pomaranczowi"
                            name="mapfor"
                            value="teamA"
                            bind:group={mapChoice}
                            disabled={mapLabels[lang].pomaranczowi.bought ===
                                true}
                        />

                        <label for="pomaranczowi" class=" radio log-orange">
                            {mapLabels[lang].pomaranczowi.variant}
                        </label>
                        <input
                            class="radio visually-hidden"
                            type="radio"
                            id="zieloni"
                            name="mapfor"
                            value="teamB"
                            bind:group={mapChoice}
                            disabled={mapLabels[lang].zieloni.bought === true}
                        />

                        <label for="zieloni" class=" radio log-green">
                            {mapLabels[lang].zieloni.variant}
                        </label>
                        <input
                            class="radio visually-hidden"
                            type="radio"
                            id="niebiescy"
                            name="mapfor"
                            value="teamD"
                            bind:group={mapChoice}
                            disabled={mapLabels[lang].niebiescy.bought === true}
                        />

                        <label for="niebiescy" class="radio log-blue">
                            {mapLabels[lang].niebiescy.variant}
                        </label>
                        <input
                            class="radio visually-hidden"
                            type="radio"
                            id="fioletowi"
                            name="mapfor"
                            value="teamC"
                            bind:group={mapChoice}
                            disabled={mapLabels[lang].fioletowi.bought === true}
                        />

                        <label for="fioletowi" class=" radio log-violet">
                            {mapLabels[lang].fioletowi.variant}
                        </label>
                    </div>
                    <button
                        class="message_form_button"
                        on:click|preventDefault={mapBought}
                        >{texts[lang].confirm}</button
                    >
                </form>
            {/if}
            {#if maps.length > 0}
                <div class="item">
                    {#each maps as trans}
                        <p>
                            {texts[lang].transaction_part1}{teamColours[lang][
                                trans[0]
                            ]}
                            {texts[lang].transaction_part2}{teamColours[lang][
                                trans[1]
                            ]}!
                        </p>
                    {/each}
                </div>
            {/if}
        </div>
    </div>
{/if}
